import styled from 'styled-components';

import { BREAKPOINTS } from 'common/styles/style-constants';

export const CallMeBlock = styled.div`
  display: flex;
  justify-content: center;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    margin-top: 33px;
    margin-bottom: 20px;
  }
`;

export const OfferImage = styled.img`
  display: block;
  margin: 0 auto 12px;
  height: 22.5vh;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    margin-bottom: 24px;
  }
`;

export const OfferDisclaimer = styled.div`
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-bottom: 12px;
`;
